import '../styles/calendar-event-palette.css';
export const INITIAL_NEW_EVENT = {
  title: '',
  description: '',
  amount: '',
  date: '',
  endDate: '',
  time: '',
  duration: '1h',
  durationCustom: '',
  type: 'meeting',
  attendees: [],
  location: '',
  priority: 'media',
  clientId: '',
  supplierId: '',
  customFields: {},
};

export const EVENT_TYPE_META = {
  meeting: {
    label: 'Meeting',
    badgeClass: 'calendar-event-tone--blue',
  },
  deadline: {
    label: 'Scadenza',
    badgeClass: 'calendar-event-tone--orange',
  },
  internal: {
    label: 'Riunione',
    badgeClass: 'calendar-event-tone--purple',
  },
  training: {
    label: 'Promemoria',
    badgeClass: 'calendar-event-tone--teal',
  },
  incasso: {
    label: 'Incasso',
    badgeClass: 'calendar-event-tone--green',
  },
  pagamento: {
    label: 'Pagamento',
    badgeClass: 'calendar-event-tone--red',
  },
};

export const CALENDAR_EVENT_TYPE_OPTIONS = [
  { value: 'meeting', label: EVENT_TYPE_META.meeting.label },
  { value: 'deadline', label: EVENT_TYPE_META.deadline.label },
  { value: 'internal', label: EVENT_TYPE_META.internal.label },
  { value: 'training', label: EVENT_TYPE_META.training.label },
  { value: 'incasso', label: EVENT_TYPE_META.incasso.label },
  { value: 'pagamento', label: EVENT_TYPE_META.pagamento.label },
];

export const PRIORITY_META = {
  alta: 'border-[var(--danger-border)] bg-[var(--danger-soft)] text-[var(--danger-text)]',
  media: 'border-[var(--warning-border)] bg-[var(--warning-soft)] text-[var(--warning-text)]',
  bassa: 'border-[var(--border-strong)] bg-[var(--primary-soft)] text-[var(--primary)]',
};
